import { Col, FormGroup, Row } from "reactstrap";
import { LabelText } from "../../Utils/Input";
import formSchema from "../../Utils/schema.json";
import { useEffect } from "react";
import { renderField } from "./constants/renderFields";
import { useSelector } from "react-redux";
import { attributeOptions } from "./constants/InitialValues";
import Select from "react-select";

export default function AttributeDetails({
  setState,
  values,
  handleChange,
  handleBlur,
  errors,
  touched,
  setFieldTouched,
  setFieldValue,
  setIsChecked,
  checked,
  setMandatoryIsChecked,
  mandatoryChecked,
  setMandatoryIsCheckedSelfcare,
  mandatoryCheckedSelfcare,
  setFieldError,
  mandatoryCheckedPersistence,
  setMandatoryIsCheckedPersistence,
  isEdit,
  categoryOptions,
}) {
  useEffect(() => {
    const isListType = values.valueType?.value === "list";
    formSchema.forEach((section) => {
      if (section.title === "Attribute" && section.sections) {
        section.sections.forEach((subSection) => {
          subSection.fields.forEach((field) => {
            if (
              field.name === "minimumValue" ||
              field.name === "maximumValue"
            ) {
              if (
                values?.valueType?.value !== "bool" &&
                values?.type?.value === "customer" &&
                values?.valueType?.value === "integer" &&
                values?.type?.value === "customer" &&
                values?.valueFormat?.value !== "sequence"
              )
                field.required = !isListType;
            }
          });
        });
      }
    });
    setState(!isListType);
  }, [values.valueType]);
  
  useEffect(() => {
    if (
      values.valueType?.value === "list" &&
      values?.type?.value === "customer"
    ) {
      setFieldValue("SelfcareAttribute", []);
    } else {
      setFieldValue("maximumValue", "");
    }
  }, [values.valueType]);

  useEffect(() => {
    const valueType = values?.valueType?.value;

    if (
      valueType === "integer" ||
      valueType === "float64" ||
      valueType === "string"
    ) {
      setFieldValue("maximumValue", 50);
    }
  }, [values?.valueType]);

  const getAttributeDataByName = useSelector(
    (state) => state.GetAttributeByName.getAttribute,
  );

  const setAttributesInitalValues = () => {
    setIsChecked(false);
    setMandatoryIsChecked(false);
    setMandatoryIsCheckedSelfcare(false);
    setMandatoryIsCheckedPersistence(false);
    setFieldValue("valueType", "");
    setFieldValue("defaultValue", "");
    setFieldValue("minimumValue", "");
    setFieldValue("maximumValue", "");
    setFieldValue("sequenceValue", "");
    setFieldValue("attributeValue", "");
    setFieldValue("SelfcareAttribute", "");
    setFieldValue("networkField", []);
    setFieldValue("category", []);
  };
  const setAttributesEditValues = (response) => {
    setIsChecked(getAttributeDataByName?.searchable);
    setMandatoryIsChecked(getAttributeDataByName?.mandatory);
    setMandatoryIsCheckedSelfcare(getAttributeDataByName?.selfcareVisible);
    setMandatoryIsCheckedPersistence(
      getAttributeDataByName?.ratedEventPersistance,
    );
    const mappedArray =
      response?.values &&
      response?.values?.map((value) => ({
        label: value,
        value: value,
      }));
    const newInitialValues = {
      name: response?.name,
      type: attributeOptions
        .find((attr) => attr.name === "type")
        ?.options?.find((option) => option.value === response?.type),
      valueType: attributeOptions
        .find((attr) => attr.name === "valueType")
        ?.options?.find((option) => option.value === response?.valueType),
      description: response?.description,
      defaultValue: response?.default,
      minimumValue: response?.minValue,
      maximumValue: response?.maxValue,
      attributeValue: mappedArray,
      SelfcareAttribute: mappedArray,
      sequenceValue: response?.sequenceValue,
      valueFormat:
        response?.sequenceValue !== ""
          ? { value: "sequence", label: "Sequence" }
          : { value: "default", label: "Default" },
      networkField: Array.isArray(response?.networkField)
        ? response?.networkField?.map((item) => ({ label: item, value: item }))
        : response?.networkField
          ? [{ label: response?.networkField, value: response?.networkField }]
          : [],
          category: Array.isArray(response?.categories)
  ? response.categories.map((item) => ({
      label: item,
      value: item,
    }))
  : [],
    };
    Object.entries(newInitialValues).forEach(([key, value]) => {
      setFieldValue(key, value);
    });
  };
  useEffect(() => {
    if (
      isEdit &&
      values?.type?.value &&
      values?.type?.value === getAttributeDataByName?.type
    ) {
      setAttributesEditValues(getAttributeDataByName);
    } else {
      setAttributesInitalValues();
    }
  }, [values?.type?.value, getAttributeDataByName]);

  useEffect(() => {
  if (values?.type?.value === "inventory") {
    setFieldValue("valueType", {
      value: "string",
      label: "Text",
    });
  }
}, [values?.type]);

  return (
    <div className="live-preview">
      {formSchema.map(
        (section, sectionIndex) =>
          section.title === "Attribute" &&
          section.sections &&
          section.sections.map((subSection, subSectionIndex) => {
            let conditionMet = false;
            const filteredFields = subSection.fields.filter((field) => {
              if (
                field.name === "attributeValue" &&
                values.valueType?.value !== "list"
              ) {
                conditionMet = true;
                return false;
              } else if (
                field.name === "SelfcareAttribute" &&
                values.valueType?.value !== "bool"
              ) {
                conditionMet = true;
                return false;
              }
              if (field.name === "searchable") {
                if (
                  !(
                    values.type?.value === "customer" &&
                    values.valueType?.value === "string"
                  )
                ) {
                  return false;
                }
              }
              if (field.name === "SelfcareAttribute") {
                if (
                  !(
                    values.type?.value === "customer" &&
                    values.valueType?.value === "bool"
                  )
                ) {
                  return false;
                }
              }
              if (field.name === "maximumValue") {
                if (
                  (values.type?.value === "customer" &&
                    values.valueType?.value === "bool") ||
                  (values.type?.value === "customer" &&
                    values.valueType?.value === "integer" &&
                    values.valueFormat?.value === "sequence")
                ) {
                  return false;
                }
              }
              if (field.name === "minimumValue") {
                if (
                  (values.type?.value === "customer" &&
                    values.valueType?.value === "bool") ||
                  (values.type?.value === "customer" &&
                    values.valueType?.value === "integer" &&
                    values.valueFormat?.value === "sequence")
                ) {
                  return false;
                }
              }
              if (field.name === "defaultValue") {
                if (
                  values.type?.value === "customer" &&
                  values.valueType?.value === "integer" &&
                  values.valueFormat?.value === "sequence"
                )
                  return false;
              }
              if (field.name === "valueFormat") {
                if (
                  !(
                    values.type?.value === "customer" &&
                    values.valueType?.value === "integer"
                  )
                ) {
                  return false;
                } else {
                  return true;
                }
              }
              if (field.name === "Selfcare") {
                if (
                  !(
                    values.type?.value === "customer" &&
                    values.valueType?.value === "bool"
                  )
                ) {
                  return false;
                } else {
                  return true;
                }
              }
              if (field.name === "ratedEventPersistence") {
                if (
                  !(
                    values.type?.value === "customer" ||
                    values.type?.value === "usage"
                  )
                ) {
                  return false;
                } else {
                  return true;
                }
              }
              if (field.name === "sequenceValue") {
                if (values.valueFormat?.value !== "sequence") {
                  return false;
                } else {
                  return true;
                }
              }
              if (field?.name === "networkField") {
                if (!(values.type?.value === "usage")) {
                  return false;
                } else {
                  return true;
                }
              }
              if (field.name === "category") {
  if (values?.type?.value !== "inventory") {
    return false;
  }

  field.type = "creatable-select";
}
              return true;
            });
            if (filteredFields.length === 0) return null;
            return (
              <Row
                className="gy-1 py-2 mt-0 pt-0"
                key={`${sectionIndex}-${subSectionIndex}`}
              >
                {filteredFields.map((field, fieldIndex) => {
                  const colElement = (
                    <Col
                      xxl={field.name === "description" || field.name === "category" ? 12 : 4}
                      md={field.name === "description" || field.name === "category" ? 12 : 6}
                      sm={12}
                      className="pe-0"
                      key={field.name}
                    >
                      <FormGroup>
                        <LabelText
                          htmlFor={field.name}
                          classLabelName={"ms-0 rv-form-label"}
                          className={"text-danger"}
                          displayText={field.label}
                          important={field.required ? "*" : ""}
                        />
                        <LabelText
                          htmlFor={field.name}
                          classLabelName={`d-block ms-0 rv-sub-label ${
                            (
                              field.type !== "Selfcare-creatable-select"
                                ? touched[field.name] && errors[field.name]
                                : errors[field.name]
                            )
                              ? "rv-label-danger"
                              : "rv-label-muted"
                          }`}
                          displayText={
                            (
                              field.type !== "Selfcare-creatable-select"
                                ? touched[field.name] && errors[field.name]
                                : errors[field.name]
                            )
                              ? errors[field.name]
                              : field.type === "switch"
                                ? field.tooltip
                                : field.placeholder
                          }
                        />
                        {renderField(
                          field,
                          handleChange,
                          handleBlur,
                          values,
                          errors,
                          touched,
                          mandatoryChecked,
                          mandatoryCheckedPersistence,
                          mandatoryCheckedSelfcare,
                          isEdit,
                          setFieldValue,
                          setFieldError,
                          setFieldTouched,
                          setMandatoryIsChecked,
                          setMandatoryIsCheckedPersistence,
                          setMandatoryIsCheckedSelfcare,
                          setIsChecked,
                          checked,
                          true,
                          categoryOptions
                        )}
                      </FormGroup>
                    </Col>
                  );
                  return colElement;
                })}
              </Row>
            );
          }),
      )}
    </div>
  );
}
